import * as React from 'react';
import moment from 'moment';
import { ICalendarState, IDay } from '../../classes/calendar';
import { connect } from 'react-redux';

import { ICalendarAppState } from '../../redux-state';
import { ICalendarAppText } from '../../redux-state/interfaces/text/calendar-app.text';
import { IEvent, IMonth } from '../../interfaces';
import GridMonthView from './grid-month.view';


interface IGridMonthExternalProps {
    monthData: IMonth<IEvent>;
}

interface StateToProps {
    text: ICalendarAppText;
}

export type GridMonthProps = IGridMonthExternalProps & StateToProps;

export class GridMonthBase extends React.Component<GridMonthProps, any> {
    render() {
        return (
            <GridMonthView {...this.props} />
        )
    }
}

function mapStateToProps(state: ICalendarAppState, ownProps: IGridMonthExternalProps): StateToProps {
    return {
        text: state.calendarText
    }
}

export default connect<StateToProps>(mapStateToProps)(GridMonthBase);